// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getCurrency = createAsyncThunk('currencySliceData/getCurrency', async () => {
    try {
        let response = await axios.get('/Currency', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getCurrencyoption = createAsyncThunk('currencySliceData/getCurrencyoption', async () => {
    try {
        let response = await axios.get('/Currency?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getCurrencyStatus = createAsyncThunk('currencySliceData/getCurrencyStatus', async () => {
    try {
        let response = await axios.get('/Currency?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteCurrency = createAsyncThunk('currencySliceData/deleteCurrency', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Currency/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Currency deleted successfully.');
        await dispatch(getCurrency());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createCurrency = createAsyncThunk('currencySliceData/createCurrency', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Currency', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Currency added succesfully.');
        await dispatch(getCurrency());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCurrency = createAsyncThunk('currencySliceData/updateCurrency', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Currency/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Currency updated succesfully.');
        await dispatch(getCurrency());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCurrencyStatus = createAsyncThunk('currencySliceData/updateCurrencyStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/Currency/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getCurrency());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const currencySlice = createSlice({
    name: 'currencySliceData',
    initialState: {
        currency: [],
        currencyoption: [],
        CurrencyStatus: []
    },
    extraReducers: (builder) => {
        builder.addCase(getCurrency.fulfilled, (state, action) => {
            state.currency = action?.payload;
            return;
        });
        builder.addCase(getCurrencyoption.fulfilled, (state, action) => {
            state.currencyoption = action?.payload;
            return;
        });
        builder.addCase(getCurrencyStatus.fulfilled, (state, action) => {
            state.CurrencyStatus = action?.payload;
            return;
        });
    }
});

export default currencySlice.reducer;
